/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ rating: NonNullable<unknown> }} Rating_ValueInputs */

const sv_rating_value = /** @type {(inputs: Rating_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Betyg ${i?.rating}`)
};

const en_rating_value = /** @type {(inputs: Rating_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rating ${i?.rating}`)
};

/**
* | output |
* | --- |
* | "Rating {rating}" |
*
* @param {Rating_ValueInputs} inputs
* @param {{ locale?: "sv" | "en" }} options
* @returns {LocalizedString}
*/
export const rating_value = /** @type {((inputs: Rating_ValueInputs, options?: { locale?: "sv" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rating_ValueInputs, { locale?: "sv" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "sv") return sv_rating_value(inputs)
	return en_rating_value(inputs)
});